import gql from 'graphql-tag';

export const ANALYTICS_CREATE = gql`
  mutation analyticsCreate($input: AnalyticsInput!) {
    analyticsCreate(input: $input) {
      action
      category
      data {
        id
        event
        path
        sessionId
      }
      correlationId
      timestamp
      level
      userId
    }
  }
`;

export const ERRORLOG_CREATE = gql`
  mutation errorLogCreate($input: ErrorInput!) {
    errorLogCreate(input: $input) {
      id
    }
  }
`;

export const NOTIFICATION_CREATE = gql`
  mutation notificationCreate($input: NotificationInput!) {
    notificationCreate(input: $input) {
      conference
      event
      id
      message
      page
    }
  }
`;

export const NOTIFICATION_UPDATE = gql`
  mutation notificationUpdate(
    $id: String!
    $callToAction: String
    $callToActionText: String
    $conference: String
    $event: String
    $imageUrl: String
    $message: String
    $page: String
    $status: String!
  ) {
    notificationUpdate(
      id: $id
      callToAction: $callToAction
      callToActionText: $callToActionText
      conference: $conference
      event: $event
      imageUrl: $imageUrl
      message: $message
      page: $page
      status: $status
    ) {
      conference
      event
      callToAction
      callToActionText
      id
      imageUrl
      message
      page
      status
    }
  }
`;
